import * as React from "react";

/**
 * Shell-Contracts der Profil-Seite (`/profil`).
 *
 * Dies ist der zentrale, verbindliche Vertrag, gegen den SP2 (Nav-User-Circle),
 * SP5 (Sektion Benachrichtigungen) und SP6 (Sektion Termine/Abwesenheiten)
 * implementieren. Die Shell (`ProfilePage`) bleibt unverändert, wenn SP5/SP6
 * ihre Stub-Sektionen gegen die echten Implementierungen tauschen — sie müssen
 * lediglich `ProfileSectionProps` erfüllen und in `PROFILE_SECTIONS` ihr
 * `enabled`-Flag flippen.
 */

/** Feste Sektions-Identität + Reihenfolge (Vorplan §2). */
export type ProfileSectionId =
  | "stammdaten"
  | "benachrichtigungen"
  | "termine"
  | "abwesenheiten";

export interface ProfileTabItem {
  id: ProfileSectionId;
  /** Tab-Beschriftung, z. B. „Stammdaten". */
  label: string;
  /** false → Tab sichtbar, aber Sektion ist Platzhalter/disabled. */
  enabled: boolean;
}

/**
 * Single source of truth für Reihenfolge + Labels. SP5 flippt
 * `benachrichtigungen.enabled` (nach SP4), SP6 flippt `termine.enabled` —
 * jeweils OHNE die Shell anzufassen.
 */
export const PROFILE_SECTIONS: ReadonlyArray<ProfileTabItem> = [
  { id: "stammdaten", label: "Stammdaten", enabled: true },
  { id: "benachrichtigungen", label: "Benachrichtigungen", enabled: true },
  { id: "termine", label: "Termine", enabled: false },
  { id: "abwesenheiten", label: "Abwesenheiten", enabled: false },
];

/**
 * Einheitliches Interface JEDER Sektions-Komponente. `ProfilePage` rendert alle
 * vier gestapelt und reicht diese Props durch. SP5/SP6 implementieren gegen
 * exakt dieses Interface — die Shell bleibt unverändert.
 */
export interface ProfileSectionProps {
  /** Stabiler Anchor — `ProfilePage` setzt die ref zum Scroll-Spy/Scroll-To. */
  sectionRef: React.RefObject<HTMLDivElement>;
  /** Aktive Sektion (für optionale Hervorhebung). */
  activeSection: ProfileSectionId;
}

/** Contract der sticky Tab-Leiste. */
export interface ProfileTabsProps {
  /** I. d. R. `PROFILE_SECTIONS`. */
  items: ReadonlyArray<ProfileTabItem>;
  activeSection: ProfileSectionId;
  /** Löst Scroll-To + State im Parent aus. */
  onSelect: (id: ProfileSectionId) => void;
}
